module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/badge/standard-badge/standard-badge.component.scss
// module id = ./src/app/features/badge/standard-badge/standard-badge.component.scss
// module chunks = main